import barba from '@barba/core';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{

	constructor(){
        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){

        const companyHead = document.querySelector('.p-index__company--title');
        const companyBg = document.querySelector('.p-index__company--bg');
        const companyContent = document.querySelector('.p-index__company--content');
        if (companyHead && companyBg && companyContent) {
            gsap.registerPlugin(ScrollTrigger);
            
            ScrollTrigger.create({
                trigger: companyHead,
                start: 'center center',
                endTrigger: companyContent,
                end: 'bottom bottom',
                pin: true,
                pinSpacing: false
            });

            if (window.innerWidth > 991) {
                ScrollTrigger.create({
                    trigger: companyBg,
                    start: 'center center',
                    endTrigger: companyContent,
                    end: 'bottom center',
                    pin: true,
                    //markers: true,
                    pinSpacing: false
                });
            } else if (window.innerWidth < 992) {
                ScrollTrigger.create({
                    trigger: companyBg,
                    start: 'top 20% top',
                    endTrigger: companyContent,
                    end: 'bottom center',
                    pin: true,
                    //markers: true,
                    pinSpacing: false
                });
            }
        }
        
        const recruitSec = document.querySelectorAll('.p-index__recruit--sec');
        if(recruitSec){
            gsap.utils.toArray(recruitSec).forEach((section, i) => {
                section.bg = section.querySelector(".p-index__recruit--bg"); 
                if (i) {
                    section.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;
                    gsap.to(section.bg, {
                        backgroundPosition: `50% ${innerHeight / 2}px`,
                        ease: "none",
                        scrollTrigger: {
                        // markers:true,
                        trigger: section,
                        scrub: .1,
                        }
                    });
                } else {
                    section.bg.style.backgroundPosition = "50% 0px"; 
                    gsap.to(section.bg, {
                        backgroundPosition: `50% ${innerHeight / 2}px`,
                        ease: "none",
                        scrollTrigger: {
                        //markers:true,
                        trigger: section,
                        start: "top top", 
                        end: "bottom top",
                        scrub: true
                        }
                    });
                }
            });
        }
    }
}